import { FC } from 'react';
import InteractiveTour from 'src/common/components/InteractiveTour/InteractiveTour';
import content from '../data/content';

const Start: FC = () => {
  return (
    <>
      <InteractiveTour content={content} />
    </>
  );
};

export default Start;
